module.exports = __webpack_public_path__ + "static/media/legacy-family.5b27cda7.jpg";